import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";
import { PublicInterceptor } from "../../../interceptors/PublicInterceptor";


export const getCuentasBancariasTotales = async () => {
    const respuesta = await PublicInterceptor(`Base/Global/Bancos/CuentasBancariasTotales`, "GET");
    return respuesta;
};
